import React, { ReactNode } from 'react';
import styles from './learn-more.module.css';
import { Text, Icon, Link } from '@tonic-ui/react';
import ExternalLink from '../../external-link/external-link';

interface PLReadmoreLinkProps {
  link?: string;
  textProps?: ReturnType<Text>;
  text?: ReactNode;
  iconProps?: ReturnType<Icon>;
}

const PLReadmoreLink = ({ link, text, iconProps, textProps }: PLReadmoreLinkProps) => (
  <ExternalLink href={link ? link : ''} showIcon={false} className={styles.learn_more}>
    <Text size="lg" fontWeight="regular" color="black:primary" {...textProps}>
      {text}
    </Text>
    <Icon
      icon="arrow-long-right"
      ml="2x"
      color="red:70"
      size="4x"
      {...iconProps}
      className={styles.animated_arrow_right}
    />
  </ExternalLink>
);

export default PLReadmoreLink;
